// eslint-disable-next-line import/prefer-default-export
export const ProgressBarStyle = {
    root: {
        '& .MuiLinearProgress-root': {
            borderRadius: '10px',
            backgroundColor: 'var(--backgroundGray)',
            '& .MuiLinearProgress-bar': {
                borderRadius: '10px',
                backgroundColor: 'var(--fashionPink)',
            },
        },
    },
};
